/**
 * Mock Members Data
 * ArcStack - KLE Tech Belagavi Campus
 * Academic Cycle 2025 - 2026
 */

export const mockMembers = [
  {
    id: 1,
    name: 'Akhilesh Joshi',
    usn: '02FE22BCS013',
    role: 'Chairperson',
    branch: 'CSE',
    year: 4,
    email: 'akhileshjoshi2004@gmail.com',
    phone: '8861814369',
    skills: ['C', 'C++', 'Python', 'SQL', 'PyTorch', 'TensorFlow', 'Overleaf', 'AWS', 'Docker', 'Kubernetes', 'Terraform', 'Git', 'Linux', 'Data Science', 'Machine Learning', 'Generative AI', 'Applied Computational Medicine', 'Cyber Security', 'Multithreaded Programming', 'Graphic Design', 'Cloud Computing', 'DevOps', 'Leadership', 'Design Thinking'],
    joinDate: '2022-08-15',
    bio: 'Driven Computer Science undergraduate at KLE Technological University with a strong foundation in AI/ML, Data Science, and DevOps. My technical journey is defined by a rigorous commitment to innovation, bridging the gap between theoretical research and scalable software solutions. I am an active researcher with multiple papers published or submitted to prestigious platforms like IEEE Xplore, Springer, and Elsevier. In these research endeavors, I have leveraged advanced technologies such as Deep Learning, Multimodal Data Analysis, and Dockerized frameworks to create solutions for Healthcare (Dynamic Avatar Generation, EEG analysis) and Cybersecurity (DDoS mitigation). Translating this theoretical knowledge into practical engineering, I have architected several end-to-end projects. My portfolio includes Packet Vision, an ML-powered DDoS detection system utilizing Deep Neural Networks; the RBI Compliance Assistant, a Generative AI solution fine-tuned on financial regulations using Mistral-7B; and ShopSync, a collaborative web platform where I implemented a complete DevOps pipeline using AWS and Docker. Beyond my technical contributions, I am deeply committed to community leadership and organizational growth. I currently serve as the Chairperson of the Coding Club, Secretary of the HR Club, and Tech Lead at the KLE Center for Technology, Innovation, and Entrepreneurship (CTIE). Additionally, my experience as a Google Student Ambassador and former Media and Publicity Lead for the IEEE Student Branch has honed my ability to lead diverse teams and drive impactful initiatives. I am currently seeking opportunities to apply my engineering skills to solve complex real-world problems.',
    image: '/images/members/akhilesh-joshi.jpg',
    linkedin: 'https://www.linkedin.com/in/akhilesh-joshi-aj2004',
    github: 'https://github.com/akhileshj2004',
    instagram: 'https://www.instagram.com/akhileshjoshi_04?igsh=cGg2dDdmcXI1bDFo',
    portfolio: 'https://packetvision.up.railway.app',
  },
  {
    id: 2,
    name: 'Anushka Singh',
    role: 'Vice Chairperson',
    branch: 'CSE',
    year: 3,
    email: 'anu48483@gmail.com',
    usn: '02FE23BCS099',
    phone: '6201579261',
    skills: ['React', 'Node.js', 'Python', 'C++', 'ML', 'Figma', 'Cloud Computing', 'Algorithms', 'DSA', 'Management', 'Web Development'],
    joinDate: '2023-08-15',
    bio: 'I\'m Anushka Singh, a dedicated third-year Computer Science Engineering student at KLE MSSCET. I\'m passionate about full-stack web development, actively exploring Data Structures and Algorithms, and continuously participating in hackathons to expand my knowledge in emerging technologies such as ML, cloud computing, and Web3.',
    image: '/images/members/anushka-singh.jpg',
    linkedin: 'https://www.linkedin.com/in/anushka-singh-2bb080298?utm_source=share_via&utm_content=profile&utm_medium=member_android',
    github: 'https://github.com/anushka48483',
    instagram: 'https://www.instagram.com/_la.riverie_?igsh=cGlwcXlobGQ5YXFr',
  },
  {
    id: 3,
    name: 'Pratik Kesarkar',
    role: 'General Secretary',
    branch: 'CSAI',
    year: 4,
    email: 'pratikkesarkar04@gmail.com',
    skills: ['Java', 'MERN Stack', 'DSA'],
    joinDate: '2022-08-15',
    bio: 'Aspiring Computer Science student focused on AI and Full Stack Development, passionate about building innovative solutions that drive growth.',
    image: '/images/members/pratik-kesarkar.jpg',
    linkedin: 'https://www.linkedin.com/in/pratik-kesarkar-2a65242a2',
    github: 'https://github.com/PRATIK-KESARKAR',
    instagram: 'https://www.instagram.com/pratik__kesarkar/',
  },
  {
    id: 4,
    name: 'Shreyas Savant',
    usn: '02FE23BCS078',
    role: 'Deputy General Secretary',
    branch: 'CSE',
    year: 3,
    email: 'shreyassavant1045@gmail.com',
    phone: '7019864016',
    skills: ['Public Relations', 'Deep Learning', 'Machine Learning', 'Java', 'Python', 'DSA', 'Coordination', 'React', 'Backend'],
    joinDate: '2023-08-15',
    bio: 'As Deputy General Secretary, I assist in overall club management and coordinate technical initiatives across teams. I have hands-on experience with backend development and React, allowing me to bridge administrative and technical operations. I am committed to ensuring smooth communication between different clusters and helping members execute ambitious projects.',
    image: '/images/members/',
    bio: 'A passionate learning enthusiast with a knack for organizing, planning, and managing workflows. I enjoy understanding new concepts, simplifying complexity, and ensuring smooth execution in any environment.',
    image: '/images/members/shreyas-savant.jpg',
    linkedin: 'https://www.linkedin.com/in/shreyas-savant-82a98531a?utm_source=share_via&utm_content=profile&utm_medium=member_android',
    github: 'https://github.com/Shreyasshreyas10',
    instagram: 'https://www.instagram.com/shreyas_savant10?igsh=MTNoZ213and1bWxq'
  },
  {
    id: 5,
    name: 'Samarth Kattimani',
    role: 'Treasurer',
    branch: 'CSE',
    year: 4,
    email: 'samarth.kattimani@kle.edu',
    skills: ['Finance', 'Management', 'Web Development'],
    joinDate: '2022-08-15',
    bio: 'I am Samarth Kattimani, a Computer Science Engineering student with a strong interest in Cloud, Artificial Intelligence, Machine Learning, and IoT. I enjoy exploring new technologies, building meaningful solutions, and continuously improving my skills. With a CGPA of 8.25, I am proud to be the first student placed from the 2026 batch. I’m a fast learner, focused, and passionate about growing in the tech field with confidence and consistency.',
    image: '/images/members/Samarth-Kattimani.jpg',
  },
  {
    id: 6,
    name: 'Aniket Patil',
    role: 'Treasurer',
    branch: 'CSE',
    year: 3,
    email: 'aniket.patil@kle.edu',
    skills: ['Finance', 'Accounting', 'Python'],
    joinDate: '2023-08-15',
    bio: 'As co-Treasurer, I partner with Samarth to manage all financial operations and maintain accurate accounting records. I bring attention to detail and financial acumen to ensure all club funds are utilized effectively. My background in Python helps me build tools for financial tracking and reporting within the club.',
    image: '/images/members/Aniket-Patil.jpg',
  },
  {
    id: 7,
    name: 'Harshit Baliyan',
    role: 'Lead (Development Team)',
    branch: 'CSE',
    year: 3,
    email: 'harshitbaliyan116@gmail.com',
    skills: ['Node.js', 'C++', 'Machine Learning', 'Deep Learning', 'UI/UX', 'Figma', 'DSA'],
    joinDate: '2023-08-15',
    bio: 'I\'m a CS student with experience in web development and DSA. I love creating clean, efficient solutions and exploring new technologies. Passionate about full-stack development, machine learning, and UI/UX design.',
    image: '/images/members/harshit-baliyan.jpeg',
    linkedin: 'https://www.linkedin.com/in/harshit-baliyan-7455942a9/',
    github: 'https://github.com/Harsh7817',
    instagram: 'https://www.instagram.com/_harshitbaliyan.__011?igsh=MW02b3k0NnB4a2J4ZA==',
  },
  {
    id: 8,
    name: 'Neil Rego',
    role: 'Lead (AI Team)',
    branch: 'CSAI',
    year: 3,
    email: 'neilrego3@gmail.com',
    usn: '02FE23BCI036',
    phone: '9731379082',
    skills: ['Java', 'Machine Learning', 'Spring Boot', 'Python', 'React', 'Data Science', 'Public Relations', 'AI'],
    joinDate: '2023-08-15',
    bio: 'I\'m Neil Rego, a CSE (AI) student interested in building practical tech solutions. I work with Java, Spring Boot, and Python, with experience in ML and deep learning. I\'m always looking to grow and connect.',
    image: '/images/members/neil-rego.jpg',
    linkedin: 'www.linkedin.com/in/neil-rego',
  },
  {
    id: 9,
    name: 'Rahul Kulkarni',
    role: 'Co-Lead (AI Team)',
    branch: 'CSAI',
    year: 4,
    email: 'Rahulkulkarni2944@gmail.com',
    skills: ['Machine Learning', 'Deep Learning', 'Python', 'Data Science'],
    joinDate: '2022-08-15',
    bio: '7th semester, CS-AI',
    image: '/images/members/rahul-kulkarni.jpeg',
    linkedin: 'https://www.linkedin.com/in/rahul-kulkarni-19890827a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
    instagram: 'https://www.instagram.com/rahul_kulkarni.xvi?igsh=MW95emd6MmNsdGdibA%3D%3D&utm_source=qr',
  },
  {
    id: 10,
    name: 'Aastha Mishra',
    role: 'Lead (Emerging Tech)',
    branch: 'CSE',
    year: 3,
    email: 'aastha1.official@gmail.com',
    skills: ['Java', 'Cloud Computing', 'Content Creation', 'Public Relations'],
    joinDate: '2023-08-15',
    bio: 'I am Aastha, a 3rd year undergraduate at KLE Technological University (KLETU) pursuing Computer Science and Engineering. I am an inquisitive explorer and learner in the realms of technology, innovation, and creativity. I am fascinated by the blend of creativity and innovation. As someone who relishes creative expression, I aspire to work on projects that embody creativity through the integration of ever-evolving technologies like Artificial Intelligence. I am also keen to learn, build, and contribute to projects in areas such as Machine Learning, Cybersecurity, UI/UX design, and emerging technologies. I am not just a Tech enthusiast but also deeply passionate about literature and actively engage in creative writing as well as content writing.',
    image: '/images/members/aastha-mishra.jpg',
    linkedin: 'https://www.linkedin.com/in/aastha-mishra-99ba71356?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
  },
  {
    id: 11,
    name: 'Prakhar Shrestha',
    role: 'Co-Lead (Emerging Tech)',
    branch: 'CSE',
    year: 3,
    email: 'prakhar.shresth01@gmail.com',
    skills: ['Java', 'Machine Learning', 'Data Science', 'DSA', 'Algorithms', 'Design', 'Blockchain', 'Web Development'],
    joinDate: '2023-08-15',
    bio: 'My name is Prakhar Shrestha, and I am a Computer Science Engineering student pursuing my B.Tech with a strong interest in technology and its evolving landscape. I have knowledge in Web Development, Machine Learning, and Java. I plan to learn App Development and Generative AI, and I am also considering areas like Blockchain and Cybersecurity. I see myself as a continuous learner who enjoys building new skills and adapting to emerging technologies. Outside academics, I play football and basketball, and I also enjoy playing the guitar.',
    image: '/images/members/prakhar-shrestha.jpg',
    linkedin: 'https://www.linkedin.com/in/prakhar-shrestha-b9527027a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    github: 'https://github.com/prakharshrestha',
    instagram: 'https://www.instagram.com/prakhar.shresth_._?igsh=cHBrMXBtN2tqN2Vv',
  },
  {
    id: 12,
    name: 'Ankit Raj',
    role: 'Lead (Competition Management)',
    branch: 'CSE',
    year: 3,
    email: 'ankitrajj23@gmail.com',
    skills: ['C++', 'WebDev', 'ML/DL', 'Machine learning', 'Data analysis'],
    joinDate: '2023-08-15',
    bio: 'Pursuing B.Tech in CSE. Proficient in Machine learning, data analysis and software development.',
    image: '/images/members/ankit-raj.jpg',
    linkedin: 'https://www.linkedin.com/in/ankit-raj-96237b369',
  },
  {
    id: 13,
    name: 'Bhumika Nagarali',
    role: 'Lead (PR Team)',
    branch: 'CSE',
    year: 3,
    email: 'bhumika.n@kle.edu',
    skills: ['Public Relations', 'Communication', 'Marketing'],
    joinDate: '2023-08-15',
    bio: 'PR and communication enthusiast with a strong learning mindset and a growing interest in technology. I enjoy crafting clear, meaningful messages and building connections that create real impact. Always exploring new skills and staying curious.',
    image: '/images/members/Bhumika-N.jpg',
  },
  {
    id: 14,
    name: 'Aryan Patil',
    role: 'Co-Lead (PR Team)',
    branch: 'CSE',
    year: 2,
    email: 'aryan.patil@kle.edu',
    skills: ['Social Media', 'Content Creation', 'Marketing'],
    joinDate: '2024-08-15',
    bio: 'I\’m Aryan Sunil Patil, a Computer Science Engineering undergraduate at KLE Technological University and the Co-Lead of the PR Cluster at ArcStack. I\’m passionate about blending technology, design, and communication to create meaningful impact.With skills in C, C++, UI/UX, design, social media management, media marketing, public relations, content creation, leadership, and communication, I enjoy taking on roles that challenge me to think creatively and collaborate effectively.I strive to build strong connections, craft compelling narratives, and contribute to communities where innovation and growth go hand in hand.',
    image: '/images/members/Aryan-Patil.jpg',
  },
  {
    id: 15,
    name: 'Adarsh Kakatkar',
    role: 'Lead (Programming Team)',
    branch: 'CSE',
    year: 3,
    email: 'adarsh.kakatkar@kle.edu',
    skills: ['C++', 'Python', 'Algorithms', 'Problem Solving'],
    joinDate: '2023-08-15',
    bio: 'I believe in change is the only constant.',
    image: '/images/members/Adarsh-Kakatkar.jpeg',
  },
  {
    id: 16,
    name: 'Vaibhav Deopa',
    role: 'Co-Lead (Programming Team)',
    branch: 'CSAI',
    year: 3,
    email: 'udaydeopa2023@gmail.com',
    skills: ['Competitive Programming', 'DSA', 'Node.js', 'Python', 'C++', 'Java'],
    joinDate: '2023-08-15',
    bio: 'You know it not the same as it was.',
    image: '/images/members/vaibhav-deopa.jpg',
    linkedin: 'https://www.linkedin.com/in/vaibhavdeopa/',
    github: 'https://github.com/VaibhavDeopa',
    instagram: 'https://www.instagram.com/vaibhav_deopa/',
  },
  {
    id: 17,
    name: 'Anusha Rokhade',
    role: 'Lead (Media & Design)',
    branch: 'CSE',
    year: 3,
    email: 'rokhadeanusha@gmail.com',
    skills: ['Design', 'Editing', 'Java', 'Machine Learning'],
    joinDate: '2023-08-15',
    bio: 'Creative media enthusiast and designer.',
    image: '/images/members/anusha-rokhade.jpg',
    linkedin: 'https://www.linkedin.com/in/anusha-rokhade-b41b72389',
  },
  {
    id: 18,
    name: 'Jaydeep Nadkarni',
    role: 'Member (Development Team)',
    branch: 'CSE',
    year: 2,
    email: 'jaydeepnadkarni123@gmail.com',
    skills: ['C', 'Python', 'Competitive Programming', 'DSA'],
    joinDate: '2024-08-15',
    bio: 'Web Developer',
    image: '/images/members/jaydeep-nadkarni.jpg',
    linkedin: 'https://www.linkedin.com/in/jaydeep-nadkarni',
    github: 'https://github.com/Jaydeep-Nadkarni',
    instagram: 'https://www.instagram.com/jaydeep_nadkarni/',
  },
  {
    id: 19,
    name: 'Shivakumar A Sindolli',
    role: 'Member (Development Team)',
    branch: 'CSE',
    year: 2,
    email: 'shivakumarshindolli@gmail.com',
    skills: ['React', 'Node.js', 'DSA'],
    joinDate: '2024-08-15',
    bio: 'I am a curious learner who enjoys coding and exploring new technologies. I am interested in web technology, AI, DSA. I enjoy working in teams and learning from others. I joined the Coding Club to grow, collaborate, and become a better developer.',
    image: '/images/members/shivakumar-a-sindolli.jpg',
    linkedin: 'https://www.linkedin.com/in/shivakumar-sindolli-7b4b69394/',
    github: 'https://github.com/ShivakumarSindolli',
    instagram: 'https://www.instagram.com/shivakumar_sindolli/?next=%2F',
  },
  {
    id: 20,
    name: 'Samiksha Yadav',
    role: 'Member (Development Team)',
    branch: 'CSE',
    year: 2,
    email: '02fe24bcs051@kletech.ac.in',
    skills: ['React', 'Node.js', 'Figma'],
    joinDate: '2024-08-15',
    bio: 'I am a Computer Science student actively learning both web development and cybersecurity. I enjoy building projects, exploring new technologies, and continuously improving my technical skills.',
    image: '/images/members/samiksha-yadav.jpeg',
    linkedin: 'https://www.linkedin.com/in/samiksha-yadav-536315308',
    github: 'https://github.com/samikshayadav-ux',
    instagram: 'https://instagram.com/samiksha872',
  },
  {
    id: 21,
    name: 'Karthik Hirenarti',
    role: 'Member (Development Team)',
    branch: 'CSE',
    year: 1,
    email: 'karthik.hirenarti@gmail.com',
    usn: '02FE25BCS044',
    phone: '7204404872',
    skills: ['Flutter', 'Java', 'C++', 'Python', 'HTML', 'CSS', 'JavaScript', 'WordPress', 'Firebase', 'Embedded Systems', 'UI/UX', 'AI/ML'],
    joinDate: '2024-08-15',
    bio: 'I am a Computer Science and Engineering student at KLE Technological University with a strong interest in building practical, user-focused technological solutions. My work spans web development, mobile app development, embedded systems, and AI-assisted applications. I have built several projects including a wearable assistive device for visually impaired users, an automated pond-cleaning mechanism, a temple website for community engagement, and an AI-powered system to detect sugarcane leaf diseases. I actively work with Flutter, Java, C++, WordPress, and embedded development tools, while exploring AI/ML applications. My goal is to develop solutions that are not only technically sound but genuinely helpful to users, making technology accessible, meaningful, and impactful.',
    image: '/images/members/karthik-hirenarti.jpg',
    linkedin: 'https://www.linkedin.com/in/karthikhirenarti/',
    github: 'https://github.com/Cartlal',
    instagram: 'https://www.instagram.com/karthikhirenarti/',
    portfolio: 'https://sites.google.com/kletech.ac.in/karthik-hirenarti/home',
    projects: [
      'https://toravilaxminarasimha.org/',
      'https://lively-valkyrie-93ca23.netlify.app/cure'
    ],
  },
  {
    id: 22,
    name: 'Divya Gour',
    role: 'Member (Development Team)',
    branch: 'CSE',
    year: 1,
    email: 'divyagour0935@gmail.com',
    skills: ['Java', 'C++', 'C', 'Web dev'],
    joinDate: '2024-08-15',
    bio: 'I am Divya Gour, a Computer Science Engineering undergraduate at KLE Technological University. I have hands-on experience in C and C++ and a solid understanding of the basics of web development and I am currently expanding my knowledge in that area, along with learning Java. I am passionate about technology and personal growth and eager to apply my skills to real-world projects.',
    image: '/images/members/divya-gour.jpg',
    linkedin: 'https://www.linkedin.com/in/divya-gour',
    github: 'https://github.com/Divya-Gour',
    instagram: 'https://www.instagram.com/divyagour._?igsh=eTJmZGIxNm9nZ3I0',
  },
  {
    id: 23,
    name: 'Abhishek Manoli',
    role: 'Member (Development Team)',
    branch: 'CSE',
    year: 1,
    email: 'abhishekmanoli2007@gmail.com',
    skills: ['DSA', 'C++', 'Social Media Marketing', 'Content Creation', 'PR', 'Editing'],
    joinDate: '2024-08-15',
    bio: 'I am a first-year Computer Science and Engineering student with a strong interest in software development, artificial intelligence, and cybersecurity. I believe in learning by doing, and I enjoy experimenting, building projects, and applying knowledge to solve real-world problems. I recently participated in the Smart India Hackathon (SIH 2025), which helped me develop teamwork, brainstorming, and problem-solving skills. I am also an active member of my college HR Club and am known for being a motivated team player with natural leadership qualities. Outside academics, I enjoy playing football, gaming, and exploring nature through trekking. I aim to grow my skills and pursue opportunities that help me become an engineer who turns ideas into meaningful solutions.',
    image: '/images/members/abhishek-manoli.jpg',
    linkedin: 'https://www.linkedin.com/in/abhishekmanoli',
    github: 'https://github.com/abhishekmanoli',
    instagram: 'https://www.instagram.com/abhishek_manoli',
  },
  {
    id: 24,
    name: 'Harshit Jakati',
    role: 'Member (AI Team)',
    branch: 'CSAI',
    year: 3,
    email: 'harshitrjakati@gmail.com',
    usn: '02FE23BCI025',
    phone: '8296049439',
    skills: ['Machine Learning', 'Deep Learning', 'Data Science'],
    joinDate: '2023-08-15',
    bio: 'Passionate about learning new technologies.',
    image: '/images/members/harshit-jakati.jpg',
    linkedin: 'www.linkedin.com/in/harshit-jakati-744232320',
    github: 'https://github.com/Hjakxx',
  },
  {
    id: 25,
    name: 'Chandrakanth D Ujjanagoudra',
    role: 'Member (AI Team)',
    branch: 'CSAI',
    year: 2,
    email: '02fe24bci049@kletech.ac.in',
    skills: ['Python', 'ML', 'Machine Learning'],
    joinDate: '2024-08-15',
    bio: 'AI Enthusiast.',
    image: '/images/members/chandrakanth-d-ujjanagoudra.jpg',
    linkedin: 'https://www.linkedin.com/in/chandrakanth-d-u-6291b0327?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    github: 'https://github.com/chandrakanth-ujjanagoudra',
  },
  {
    id: 26,
    name: 'Arpita Malalikar',
    role: 'Member (AI Team)',
    branch: 'CSE',
    year: 2,
    email: 'arpitamalalikar@gmail.com',
    skills: ['Python', 'Machine Learning', 'Algorithms', 'DSA'],
    joinDate: '2024-08-15',
    bio: 'I\'m Arpita, a Computer Science student with a strong interest in Python, C programming, and the fundamentals of machine learning. I\'m continuously improving my coding skills and building a solid foundation in algorithms and problem-solving. I joined the club to learn more, work on real projects, and collaborate with people who share a passion for technology.',
    image: '/images/members/arpita-malalikar.jpg',
    linkedin: 'https://www.linkedin.com/in/arpita-malalikar-20652b375',
  },
  {
    id: 27,
    name: 'Vaishnavi Modekar',
    usn: '02fe24bcs060',
    role: 'Member (AI Team)',
    branch: 'CSE',
    year: 2,
    email: 'vaishnavimodekar@gmail.com',
    phone: '8722343377',
    skills: ['C', 'C++', 'Python', 'AI', 'Machine Learning'],
    joinDate: '2024-08-15',
    bio: '2nd year CSE student at KLE technological University',
    image: '/images/members/vaishnavi-modekar.jpg',
    linkedin: 'https://www.linkedin.com/in/vaishnavi-modekar-524b90305?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    github: 'https://github.com/VaishnaviModekar/weather',
    instagram: 'https://share.google/pYN8by7bvn5xFRvl3',
  },
  {
    id: 28,
    name: 'Chinmayi Talwar',
    role: 'Member (AI Team)',
    branch: 'CSE',
    year: 1,
    email: 'chinmayitalwar9@gmail.com',
    skills: ['C++', 'Python', 'DSA', 'Web Development'],
    joinDate: '2024-08-15',
    bio: 'I am Chinmayi from Belgaum. Hobbies include playing badminton and watching anime. I am hard-working, focused, and eager to learn new things. My ambition is to become an engineer with strong technical skills.',
    image: '/images/members/chinmayi-talwar.jpg',
    linkedin: 'https://www.linkedin.com/in/chinmayi-talwar-005351392',
    github: 'https://github.com/chinmayitalwar28',
    instagram: 'https://www.instagram.com/chinmayi_s_t?igsh=MXFhc3o4bHhka2h3NA==',
  },
  {
    id: 29,
    name: 'Shreya Kalaj',
    role: 'Member (AI Team)',
    branch: 'CSE',
    year: 1,
    email: 'kalajshreya@gmail.com',
    usn: '20FE25BCS010',
    phone: '9980527134',
    skills: ['C++', 'Python', 'Public Relations', 'AI/ML', 'Data Structures', 'Problem Solving'],
    joinDate: '2024-08-15',
    bio: 'I have strong technical skills and a deep interest in AI/ML, data structures, and problem-solving. I consider myself a quick learner with good logical thinking, and I work well in teams with effective communication. I am hardworking, consistent, and always focused on improving myself. My hobbies include dancing, reading tech articles, and enjoying sports and music. My career goal is to build strong skills in software development and artificial intelligence to contribute meaningfully to future technological advancements.',
    image: '/images/members/shreya-kalaj.jpg',
    linkedin: 'https://www.linkedin.com/in/shreya-kalaj-28162839b',
  },
  {
    id: 30,
    name: 'Varshini Kulkarni',
    role: 'Member (AI Team)',
    branch: 'CSE',
    year: 1,
    email: 'varshini.vk1006@gmail.com',
    skills: ['C++', 'Python', 'Arduino', 'Problem Solving', 'Logical Thinking', 'Machine Learning'],
    joinDate: '2024-08-15',
    bio: 'I am a first-year engineering student and a member of the Coding Club, with an interest in programming and technology. I enjoy learning through hands-on work and small projects that help me understand concepts better. Currently, I am developing my skills in C++, Python, and I look forward to improving through experience, collaboration, and participation in technical activities organized by the club.',
    image: '/images/members/varshini-kulkarni.jpg',
    linkedin: 'https://www.linkedin.com/in/varshini-kulkarni-b25541374?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    github: 'https://github.com/varshinivk1006-create',
    instagram: 'https://www.instagram.com/_varshini013/?hl=en',
  },
  {
    id: 31,
    name: 'Varsha Balewadimath',
    role: 'Member (AI Team)',
    branch: 'CSE',
    year: 1,
    email: 'varshabalewadimath@gmail.com',
    skills: ['Python', 'Machine Learning', 'AI', 'Data Science'],
    joinDate: '2024-08-15',
    bio: 'I am Varsha Balewadimath from Gadag. I am a hard-working and focused 1st year CSE student with an eagerness to learn new things. My hobbies include playing volleyball and watching movies. I am ambitious to become an engineer and passionate about exploring machine learning and artificial intelligence applications.',
    image: '/images/members/varsha-balewadimath.jpg',
    linkedin: 'https://www.linkedin.com/in/varsha-balewadimath-2352b5398?utm_source=share_via&utm_content=profile&utm_medium=member_android',
    github: 'https://github.com/varshacb26',
    instagram: 'https://www.instagram.com/_varsha_265?igsh=ajM1aTM1ZjA3cGo5',
  },
  {
    id: 32,
    name: 'Manmohan Havanur',
    role: 'Member (Emerging Tech)',
    branch: 'CSAI',
    year: 1,
    email: 'manmohan.havanur@gmail.com',
    skills: ['Python', 'Cybersecurity', 'Ethical Hacking', 'Machine Learning', 'Penetration Testing', 'Linux', 'Network Security'],
    joinDate: '2024-08-15',
    bio: 'Cybersecurity-focused CSAI student with expertise in ethical hacking and penetration testing. Proficient in Python for security automation and network analysis. Trained in offensive security techniques and web application security. Eager to build innovative solutions at the intersection of AI and cybersecurity.',
    image: '/images/members/Manmohan-Havanur.jpg',
    linkedin: 'https://www.linkedin.com/in/manmohan-havanur',
    github: 'https://github.com/I-manmohan',
    instagram: 'https://www.instagram.com/manmohan_havanur?igsh=aDRjOHV2NzJtYXNp&utm_source=ig_contact_invite',
  },
  {
    id: 33,
    name: 'Rudra Kulkarni',
    role: 'Member (Emerging Tech)',
    branch: 'ECE',
    year: 1,
    email: 'rudrakulkarni1142@gmail.com',
    skills: ['IoT', 'Arduino', 'Python', 'Electronics'],
    joinDate: '2024-08-15',
    bio: 'I am Rudra Kulkarni, a first-year E&C student at KLE Tech. I love building things mostly IoT projects and experimenting with code until it behaves. I\'m super excited to be part of the Emerging Technologies-Coding Club and create cool stuff.',
    image: '/images/members/rudra-kulkarni.jpg',
    linkedin: 'https://in.linkedin.com/in/rudra-kulkarni-773023393',
    github: 'https://github.com/rudra1142',
    instagram: 'https://www.instagram.com/rudrakulkarnii',
  },
  {
    id: 34,
    name: 'Siddu Patil',
    role: 'Member (Emerging Tech)',
    branch: 'ECE',
    year: 1,
    email: 'patilsiddu266@gmail.com',
    skills: ['IoT', 'Arduino IDE', 'ESP32'],
    joinDate: '2024-08-15',
    bio: 'ECE freshman passionate in learning programming, Arduino IDE, and IoT development. Skilled with ESP32, relays, servos, steppers, and DC motors.',
    image: '/images/members/siddu-patil.jpg',
    linkedin: 'https://www.linkedin.com/in/siddu-patil-27ab46395',
    github: 'https://github.com/patilsiddu',
    instagram: 'https://www.instagram.com/_siddangouda.patil_?igsh=MTRweXV1dzBkOXFkZw%3D%3D&utm_source=qr',
  },
  {
    id: 35,
    name: 'Shivalila Hayyal',
    role: 'Member (Emerging Tech)',
    branch: 'CSE',
    year: 2,
    email: 'lilahayyal912@gmail.com',
    usn: '02FE24BCS072',
    phone: '8217873697',
    skills: ['C++', 'Gen AI', 'HTML', 'Cybersecurity'],
    joinDate: '2024-08-15',
    bio: 'I am passionate about new technologies specially AI (Gen AI), cybersecurity.',
    image: '/images/members/shivalila-hayyal.jpg',
    linkedin: 'https://www.linkedin.com/in/shivalila-hayyal-011913346?utm_source=share_via&utm_content=profile&utm_medium=member_android',
  },
  {
    id: 36,
    name: 'Namrata Basaragi',
    role: 'Member (Emerging Tech)',
    branch: 'CSE',
    year: 1,
    email: 'namratabasaragi@gmail.com',
    skills: ['C', 'Web3'],
    joinDate: '2024-08-15',
    bio: 'I am Namrata Basaragi, a 1st year Computer Science student. I am eager to learn new things and explore technology, particularly in the Web3 and Blockchain space.',
    image: '/images/members/Namrata-Basaragi.jpg',
    linkedin: 'https://www.linkedin.com/in/namrata-basaragi-49556539b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    instagram: 'https://www.instagram.com/namrata_b06?igsh=MWVucHIzc2YwZGFoaA==',
  },
  {
    id: 37,
    name: 'Aditya M Hiremath',
    role: 'Member (Emerging Tech)',
    branch: 'CSE',
    year: 1,
    email: 'adityahiremath1024@gmail.com',
    skills: ['Frontend', 'C', 'JavaScript', 'Web Development'],
    joinDate: '2024-08-15',
    bio: 'I\'m Aditya M Hiremath, a 1st year CSE student passionate about web development and programming. I enjoy building user-friendly interfaces and exploring new technologies.',
    image: '/images/members/aditya-hiremath.jpg',
    linkedin: 'https://www.linkedin.com/in/aditya-hiremath-2a95012a1',
    github: 'https://github.com/adityahiremath449',
    instagram: 'https://www.instagram.com/aditya_____2416?igsh=NzB5cDBld2NodGhk',
  },
  {
    id: 38,
    name: 'Daivik Naik',
    role: 'Member (Competition Management)',
    branch: 'CSE',
    year: 3,
    email: 'daiviknaik23@gmail.com',
    skills: ['Python', 'C', 'C++', 'Machine learning', 'Deep Learning', 'Cloud Computing', 'Java', 'Computer Vision'],
    joinDate: '2024-08-15',
    bio: 'I\'m a third-year Computer Science Engineering student with a strong interest in software development and intelligent technologies. I enjoy working with Python, C, C++, and Java, and I actively explore Machine Learning, Deep Learning, Computer Vision, and Cloud Computing to build practical, real-world solutions.',
    image: '/images/members/daivik-naik.png',
    linkedin: 'www.linkedin.com/in/daiviknaik',
    github: 'https://github.com/daiviknaik23',
    instagram: 'https://www.instagram.com/daivik.p.n_081/',
  },
  {
    id: 39,
    name: 'Srushti Payannawar',
    role: 'Member (Competition Management)',
    branch: 'CSE',
    year: 1,
    email: 'srushtipayannavar0@gmail.com',
    usn: '02FE25BCS114',
    phone: '7411265448',
    skills: ['C++', 'Core Java', 'Problem Solving', 'Algorithms'],
    joinDate: '2024-08-15',
    bio: 'I\'m a passionate problem-solving enthusiast with a strong interest in algorithms and competitive programming. I enjoy tackling complex algorithmic challenges and continuously improving my problem-solving skills. As a member of Competition Management, I aim to help organize coding contests and inspire peers to excel.',
    image: '/images/members/srushti-payannawar.jpg',
  },
  {
    id: 40,
    name: 'Sumedha Upadhye',
    role: 'Member (Competition Management)',
    branch: 'ECE',
    year: 1,
    email: 'upadhyesumedha395@gmail.com',
    skills: ['IoT', 'Public Relations', 'Arduino IDE'],
    joinDate: '2024-08-15',
    bio: 'ECE freshman learning programming, Arduino IDE, and IoT development. Skilled with ESP32, relays, servos, steppers, and DC motors.',
    image: '/images/members/sumedha-upadhye.jpg',
    linkedin: 'https://www.linkedin.com/in/sumedha-upadhye-444172385?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    github: 'https://github.com/usumedha8-afk',
    instagram: 'https://www.instagram.com/sumedha___91?igsh=MTM1b2U0M3JhYzcyZQ==',
  },
  {
    id: 41,
    name: 'Tanusha',
    role: 'Member (Competition Management)',
    branch: 'CSE',
    year: 3,
    email: 'tanisha@kle.edu',
    skills: ['Algorithms', 'Problem Solving'],
    joinDate: '2023-08-15',
    bio: 'I\'m an algorithm design enthusiast fascinated by elegant solutions to complex problems. I spend my time studying advanced algorithms, optimizing solutions, and participating in competitive programming. I\'m committed to helping newer members develop strong algorithmic thinking and competitive coding skills.',
    image: '/test-profile.svg',
  },
  {
    id: 42,
    name: 'Vaibhav Rajshekhar Lakkashetti',
    role: 'Member (Competition Management)',
    branch: 'CSE',
    year: 1,
    email: 'vaibhavrlakkashetti@gmail.com',
    skills: ['Python', 'DSA and algorithms', 'Machine learning'],
    joinDate: '2024-08-15',
    bio: 'I have done my schooling in Dnyan Prabodhan Mandir ICSE board school and my PUC State board in KLE Independent college.',
    image: '/images/members/vaibhav-lakkashetti.jpeg',
    linkedin: 'https://www.linkedin.com/in/vaibhav-lakkashetti-26116338a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
    github: 'https://github.com/vaibhavrlakkashetti-08',
    instagram: 'https://www.instagram.com/vaibhavshetty_82?igsh=eWtjOTh0bzVyOTk4&utm_source=qr',
  },
  {
    id: 43,
    name: 'Shreya Pai',
    role: 'Member (Competition Management)',
    branch: 'CSE',
    year: 2,
    email: 'shreya.pai7@gmail.com',
    skills: ['Problem Solving', 'Algorithms'],
    joinDate: '2024-08-15',
    bio: 'I\’m Shreya S Pai, a 2nd-year CS and AI student who enjoys figuring out how things work in code. I’m building a solid base in programming and problem-solving, especially through DSA and algorithmic thinking. I’ve recently started getting into Java and exploring its concepts to understand structure and logic better. I’m also learning SQL because I like understanding how data is stored and accessed behind the scenes. Outside academics, I love dancing and anything creative that helps me reset.',
    image: '/images/members/shreya-pai.jpg',
  },
  {
    id: 44,
    name: 'Sanaha Mugutkhan',
    role: 'Member (Competition Management)',
    branch: 'CSE',
    year: 1,
    email: 'Mansurcordevo@gmail.com',
    usn: '02FE25BCS078',
    phone: '7019696411',
    skills: ['Algorithms', 'Public Relations', 'Content Creation'],
    joinDate: '2024-08-15',
    bio: 'I am Sanaha Mugatakhan, a first-year Computer Science engineering student at KLE Sheshgiri. I am an active member of the Coding Club and enjoy exploring new technologies, creative ideas, and innovative solutions. I have a dynamic personality—confident, curious, and disciplined—with strong leadership qualities. My interests in karate, dance, and sports have helped me stay focused, energetic, and team-oriented. I love taking on challenges, learning continuously, and contributing positively to any group I\'m part of.',
    image: '/images/members/sanaha-mugutkhan.jpg',
    linkedin: 'https://www.linkedin.com/in/sanaha-mugatakhan-966a1a398?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
  },
  {
    id: 45,
    name: 'Pavitra H',
    role: 'Member (PR Team)',
    branch: 'CSE',
    year: 1,
    email: 'pavitrahalleppanavar@gmail.com',
    skills: ['Communication', 'Social Media', 'Marketing'],
    joinDate: '2024-08-15',
    bio: 'Im a 19 year old pursuing her Bachelors in Engineering, CS. I am passionate about public speaking, elocution, debate and so on. On the other hand, my hobbies include singing, playing instruments and so on.',
    image: '/images/members/Pavitra-H.jpg',
  },
  {
    id: 46,
    name: 'Sneha Hundekar',
    role: 'Member (PR Team)',
    branch: 'CSE',
    year: 2,
    email: 'hundekarsneha893@gmail.com',
    skills: ['Public Relations', 'Content Creation'],
    joinDate: '2024-08-15',
    bio: 'I am a dedicated tech learner with strong interest in programming and emerging technologies. I enjoy solving problems through coding and adapting to new tools quickly. I communicate well, work responsibly in teams, and stay committed to completing my tasks. I aim to build a strong career in the technology field through continuous learning and practical experience.',
    image: '/images/members/Sneha-Hundekar.jpeg',
  },
  {
    id: 47,
    name: 'Saamiya Shaikh',
    role: 'Member (PR Team)',
    branch: 'CSAI',
    year: 1,
    email: 'saamishaikh007@gmail.com',
    usn: '02FE25BCI001',
    phone: '7259424153',
    skills: ['Public Relations', 'DSA', 'Machine Learning', 'Web Development'],
    joinDate: '2024-08-15',
    bio: 'I\'m Saamiya Shaikh, a Computer Science and Artificial Intelligence undergraduate at KLE Tech University. I\'m passionate about solving problems through technology, with a growing interest in data-driven decision making, machine learning, and human-centered design. I enjoy exploring how intelligent systems can simplify real-world challenges, and I\'m continuously building my skills through academic projects, hands-on practice, and participation in campus clubs like HR and Literary Committee.',
    image: '/images/members/saamiya-shaikh.jpg',
    linkedin: 'https://www.linkedin.com/in/saamiya-i-shaikh-28a765334?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
    instagram: 'https://www.instagram.com/saamiyaa.shaikh?igsh=MTZuczdlYzZjY3d6cg%3D%3D&utm_source=qr',
  },
  {
    id: 48,
    name: 'Mallikarjunagouda Patil',
    role: 'Member (PR Team)',
    branch: 'CSAI',
    year: 1,
    email: 'mallikarjunagoudapatil864@gmail.com',
    skills: ['C++', 'C', 'Art', 'Team Management'],
    joinDate: '2024-08-15',
    bio: 'I am Mallikarjungouda Patil, currently pursuing Computer Science (AI) at KLE Sheshgiri College, Belgaum. I have a keen interest in coding, anime, and traveling, and I aspire to become a VFX and Animation Artist. I completed my Pre-University education (11th and 12th) at RLS PU College of Science, Belgaum. I completed my 1st to 10th education at St. Xavier\'s High School, where I served as the Speaker of the School Cabinet in 10th grade.',
    image: '/images/members/mallikarjunagouda-patil.png',
    linkedin: 'https://www.linkedin.com/in/mallikarjungouda-patil-889174398?utm_source=share_via&utm_content=profile&utm_medium=member_android',
    github: 'https://github.com/Mallikarjungouda-28',
  },
  {
    id: 49,
    name: 'Pranjali Mutagekar',
    role: 'Member (PR Team)',
    branch: 'CS',
    year: 3,
    email: '02fe23bcs151@kletech.ac.in',
    skills: ['C'],
    joinDate: '2023-08-15',
    bio: 'I am currently Pursuing Engineering in Computer Science in KLE technological University MSS Sheshgiri Belagavi, I am very Enthusiastic about learning new things.',
    image: '/images/members/Pranjali-Mutagekar.jpg',
  },
  {
    id: 50,
    name: 'Spandana RB',
    branch: 'CSE',
    usn: '02fe25bcs416',
    role: 'Member (PR Team)',
    year: 2,
    email: '02fe25bcs416@kletech.ac.in',
    phone: '8105972071',
    skills: ['Node.js', 'Java', 'UI/UX Design', 'PR', 'Public Relations', 'Content Creation', 'Social Media', 'Full Stack Development'],
    joinDate: '2024-08-15',
    bio: 'Myself Spandana Bathula from CS dept and I\'m a member of PR team of coding Club. Worked for 8 months in P4U healthcare solutions company on full stack and have gained knowledge in web developing.',
    image: '/images/members/spandana-b.jpg',
    linkedin: 'https://www.linkedin.com/in/spandana-b-5a2b83343/',
  },
  {
    id: 51,
    name: 'Lomesh Jangde',
    role: 'Member (Programming Team)',
    branch: 'CSAI',
    year: 3,
    email: 'ansukujangde.13@gmail.com',
    skills: ['C++', 'DSA', 'Web Development', 'Video Editing', 'Public Speaking', 'Content Creation'],
    joinDate: '2023-08-15',
    bio: 'Solving problems, enjoying the process.',
    image: '/images/members/lomesh-kumar.jpg',
    linkedin: 'www.linkedin.com/in/lomesh-jangde-8572a7311',
    github: 'https://github.com/LomeshKuJangde',
    instagram: 'https://www.instagram.com/lomesh_jangde_/',
  },
  {
    id: 52,
    name: 'Arun Mokashi',
    role: 'Member (Programming Team)',
    branch: 'CSAI',
    year: 3,
    email: 'arunmokashi2105@gmail.com',
    skills: ['Java', 'python', 'Machine Learning', 'Deep Learning', 'Data Science', 'Algorithms', 'DSA'],
    joinDate: '2023-08-15',
    bio: 'Hello, everyone! I\'m Arun Mokashi, a third-year student. Currently, I\'m sharpening my skills in two directions: getting better at solving algorithm problems (LeetCode is my daily hobby) and learning to write cleaner, more efficient code every day! As a third-year AI student, I\'m fascinated by how machines can be trained to think in their own way, and I\'m also working on improving my coding skills by contributing to open-source projects. My technical toolkit includes Java and Python, along with a growing focus on Machine Learning, Deep Learning, and DSA.',
    image: '/images/members/arun-kumar.png',
    linkedin: 'https://www.linkedin.com/in/arun-kumar-mokashi-4062ba2b2/',
    github: 'https://github.com/arunkumar-ak21',
  },
  {
    id: 53,
    name: 'Samarth Narvekar',
    role: 'Member (Programming Team)',
    branch: 'Computer Science',
    year: 3,
    email: 'samarthnarvekar34@gmail.com',
    skills: ['C++', 'Algorithms', 'Competitive Programming'],
    joinDate: '2023-08-15',
    bio: 'Algorithm design specialist',
    image: '/images/members/Samarth-Narvekar.jpg',
  },
  {
    id: 54,
    name: 'Darshan Kittur',
    role: 'Member (Programming Team)',
    branch: 'CSE',
    year: 2,
    email: 'darshankittur79@gmail.com',
    skills: ['C', 'cpp', 'python'],
    joinDate: '2024-08-15',
    bio: 'I’m Darshan Kittur, a student and an aspiring software developer with a strong passion for technology, coding, and problem-solving. I have experience in HTML, Python, C, and Git/GitHub, and I take pride in my communication and teamwork skills. My interests include web development, learning new technologies, art, and music. I’m always eager to grow, explore, and improve in the tech field.',
    image: '/images/members/darshan-kittur.jpg',
    linkedin: 'https://www.linkedin.com/in/darshan-kittur-65532a326?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    github: 'https://github.com/darshankittur79',
    instagram: 'https://www.instagram.com/darshankittur_79?igsh=MTZsc3ZkY3hjZHQxbQ==',
  },
  {
    id: 55,
    name: 'Namrata Suryavanshi',
    role: 'Member (Programming Team)',
    branch: 'CSE',
    year: 2,
    email: 'namratasuryavanshi422@gmail.com',
    skills: ['C++', 'Competitive programming', 'Algorithm', 'DSA'],
    joinDate: '2024-08-15',
    bio: 'A focused and enthusiastic learner who believes in continuous improvement. I have a keen interest in computer science, coding, and developing real-world solutions.',
    image: '/images/members/namrata-suryavanshi.png',
    linkedin: 'https://www.linkedin.com/in/namrata-suryavanshi-848024392',
    github: 'https://github.com/namratasuryavanshi422-coder',
  },
  {
    id: 56,
    name: 'Rikhil Gopi',
    role: 'Member (Programming Team)',
    branch: 'CSE',
    year: 2,
    email: 'rikhilgopi@gmail.com',
    skills: ['Java', 'C++', 'Python', 'Algorithms', 'DSA'],
    joinDate: '2024-08-15',
    bio: 'I\'m Rikhil Sudhir Gopi, a 2nd-year Computer Science student with experience in C++, Java, and Python, along with strong strengths in algorithms and data structures. I\'m naturally curious and enjoy understanding how things work, which drives me to explore new areas in technology. I\'m currently learning and experimenting with both web development and machine learning as I continue to build and expand my technical abilities.',
    image: '/images/members/rikhil-gopi.jpg',
    linkedin: 'https://www.linkedin.com/in/rikhil-gopi-a71713312?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    github: 'https://github.com/rik0013',
  },
  {
    id: 57,
    name: 'Suprita Hongal',
    role: 'Member (Programming Team)',
    branch: 'CSAI',
    year: 2,
    email: '02fe24bci045@kletech.ac.in',
    skills: ['C', 'C++', 'DSA', 'Problem-solving', 'HTML', 'CSS'],
    joinDate: '2024-08-15',
    bio: 'Name: Suprita Hongal. Department: CSE(AI) Year: 2nd Skills: C, C++, DSA, HTML, CSS. Interests: Problem-solving, coding challenges, building small projects, learning full-stack Coding Club Member: Yes Achievements: - Participated in coding sessions/workshops - Learning DSA & development Goal: To improve my coding skills and work on real projects with the club team.',
    image: '/images/members/suprita-hongal.jpg',
    linkedin: 'https://www.linkedin.com/in/suprita-hongal-77584933b',
    github: 'https://github.com/SupritaHongal',
  },
  {
    id: 58,
    name: 'Ankitraj Sharma',
    role: 'Member (Programming Team)',
    branch: 'ECE',
    year: 1,
    email: 'ankitsam2006@gmail.com',
    usn: '02FE25BEC052',
    phone: '8431604951',
    skills: ['C', 'C++', 'Java', 'HTML', 'CSS', 'JavaScript', 'Competitive Programming', 'IoT', 'Content Creation', 'Deep Learning'],
    joinDate: '2024-08-15',
    bio: 'I\'m Ankitraj A Sharma, a 1st semester Engineering student. My hobbies include exploring new coding challenges, experimenting with web designs, and learning emerging technologies. I\'m proficient in C, C++, and Java (beginner level), with web development skills in HTML, CSS, and JavaScript. I\'m enthusiastic about learning frameworks and modern tools for web applications, and interested in exploring projects that combine hardware, software, and web integration.',
    image: '/images/members/ankitraj-sharma.jpg',
    linkedin: 'https://www.linkedin.com/in/ankit-sharma-305083393?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
    github: 'https://github.com/ankitsam2006-bot',
    instagram: 'https://www.instagram.com/ankit_sam24?utm_source=qr&igsh=MTd4ZnNlaHBpOW83ZQ==',
  },
  {
    id: 59,
    name: 'Laxmi Patil',
    role: 'Member (Programming Team)',
    branch: 'CSE',
    year: 1,
    email: 'laxminivrutipatil@gmail.com',
    usn: '02FE25BCS067',
    phone: '7676316863',
    skills: ['C', 'C++'],
    joinDate: '2024-08-15',
    bio: 'I am a first year student of CSE. New to programming but eager to learn new things and explore technology and learn to work with team.',
    image: '/images/members/laxmi-patil.jpeg',
    linkedin: 'https://www.linkedin.com/in/laxmi-patil-51526a392?utm_source=share_via&utm_content=profile&utm_medium=member_android',
  },
  {
    id: 69,
    name: 'Siddhi',
    role: 'Member (Programming Team)',
    branch: 'CSE',
    year: 1,
    email: 'siddhi@kle.edu',
    skills: ['C++', 'Problem Solving'],
    joinDate: '2024-08-15',
    bio: 'Programming enthusiast',
    image: '/test-profile.svg',
  },

  {
    id: 61,
    name: 'Omganesh Matiwade',
    role: 'Member (Media & Design)',
    branch: 'CSE',
    year: 2,
    email: 'omganeshmatiwade007@gmail.com',
    skills: ['Java', 'C++', 'DSA', 'Data Science', 'Cybersecurity'],
    joinDate: '2024-08-15',
    bio: 'I am Omganesh, a 2nd-year Computer Science and Engineering student at KLE Technological University. I have a strong academic interest in computing and a growing passion for Data Science, Data Analytics, and Cybersecurity. I have experience in programming with C++, Java, and Python, and also work with web technologies such as HTML, CSS, and JavaScript.',
    image: '/images/members/omganesh-matiwade.png',
    linkedin: 'https://www.linkedin.com/in/omganesh-r-matiwade-08a694330?utm_source=share_via&utm_content=profile&utm_medium=member_android',
    github: 'https://github.com/Omganesh014',
    instagram: 'https://www.instagram.com/omganesh_014?igsh=ZThoNWo1Yzc4MnBo',
  },
  {
    id: 62,
    name: 'Shlok Daga',
    usn: '02FE25BCI023',
    role: 'Member (Media & Design)',
    branch: 'CSAI',
    year: 1,
    email: 'shlokdaga942@gmail.com',
    phone: '7019021344',
    skills: ['Editing', 'PR', 'Video Editing', 'Social Media Marketing', 'Public Relations'],
    joinDate: '2024-08-15',
    bio: 'I am shlok daga ,studying in 1st year engineering in AI engineering',
    image: '/images/members/shlok-daga.jpg',
    linkedin: 'https://www.linkedin.com/in/shlok-daga-051bb2298?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
    github: 'https://github.com/shlokdaga942-afk',
    instagram: 'https://www.instagram.com/shlokkkzzzz?igsh=dHFoemVmYzMyN2o0',
  },
  {
    id: 63,
    name: 'Fatima',
    role: 'Member (Media & Design)',
    branch: 'CSE',
    year: 2,
    email: 'fatima@kle.edu',
    skills: ['Video Editing', 'Design'],
    joinDate: '2024-08-15',
    bio: 'Video editing specialist',
    image: '/test-profile.svg',
  },
  {
    id: 64,
    name: 'Shantkumar',
    role: 'Member (Media & Design)',
    branch: 'CSE',
    year: 1,
    email: 'shantkumar@kle.edu',
    skills: ['Design', 'Creativity'],
    joinDate: '2024-08-15',
    bio: 'Creative designer',
    image: '/test-profile.svg',
  },
  {
    id: 65,
    name: 'Prasanna Hosmani',
    role: 'Member (Media & Design)',
    branch: 'CSAI',
    year: 1,
    email: 'prasannahosmani794@gmail.com',
    skills: ['Design', 'Video Editing', 'Algorithms', 'Social Media Marketing', 'Content Creation'],
    joinDate: '2024-08-15',
    bio: 'I\'m Prasanna Hosmani, an aspiring AI Engineer and content creator passionate about technology, creativity, fitness, and dance. I\'m currently pursuing AI Engineering at KLE Sheshgiri College, building strong foundations in artificial intelligence while developing skills in Canva design, short-form video editing, storytelling, and personal growth.',
    image: '/images/members/prasanna-hosmani.png',
    linkedin: 'https://www.linkedin.com/in/prasanna-hosmani-844222398',
    github: 'https://github.com/Pras-preneur',
    instagram: 'https://www.instagram.com/http.pras?igsh=Y201MGVhY2ZtZzF1&utm_source=qr',
  },
  {
    id: 66,
    name: 'Aditya Deshpande',
    role: 'Member (Media & Design)',
    branch: 'CSE',
    year: 3,
    email: 'aditya.deshpande@kle.edu',
    skills: ['Graphic Design', 'Video Editing'],
    joinDate: '2023-08-15',
    bio: 'Creative designer',
    image: '/test-profile.svg',
  },
  {
    id: 67,
    name: 'Ayush Shetty',
    role: 'Member (Media & Design)',
    branch: 'CSE',
    year: 3,
    email: 'ayushshetty201@gmail.com',
    skills: ['UI/UX', 'Figma', 'Design'],
    joinDate: '2023-08-15',
    bio: 'Interested in Python,java,design,design video editing and completing Engineering.',
    image: '/images/members/Ayush-Shetty.jpeg',
  },
  {
    id: 68,
    name: 'Soumya Honnaik',
    role: 'Member (Media & Design)',
    branch: 'CSE',
    year: 3,
    email: 'soumya.honnaik@kle.edu',
    skills: ['Graphic Design', 'Branding'],
    joinDate: '2023-08-15',
    bio: 'Brand and graphic designer',
    image: '/test-profile.svg',
  },
  {
    id: 69,
    name: 'Sarvadnya Patil',
    role: 'Member (Development Team)',
    branch: 'CSE',
    year: 1,
    email: 'sarvadnyapatil04@gmail.com',
    skills: ['Html',' CSS', 'JavaScript', 'Node.js', 'React'],
    joinDate: '2025-11-25',
    bio: 'My name is Sarvadnya Patil, and I am a first-year Computer Science and Engineering student at KLE Technological University with a strong interest in full-stack web development. I have mastered C and C++ and enjoy creating clean, user-friendly frontend designs along with efficient backend logic. I am known for strong analytical thinking, logical reasoning, and clear problem-solving ability, and I am focused on building practical projects that help me grow as a developer.',
    image: '/images/members/Sarvadnya-Patil.jpg',
    linkedin:'https://www.linkedin.com/in/sarvadnya-patil-946440393/',
    github:'https://github.com/Sarvadnya-Patil',
    instagram:'https://www.instagram.com/sarvadnyapatil_004',
  }
];

export function getAllRoles() {
  const roles = mockMembers.map((member) => member.role);
  return [...new Set(roles)].sort();
}

/**
 * Get all unique branches
 * @returns {Array} Array of unique branches
 */
export function getAllBranches() {
  const branches = mockMembers.map((member) => member.branch);
  return [...new Set(branches)].sort();
}

/**
 * Get all unique years
 * @returns {Array} Array of unique years
 */
export function getAllYears() {
  const years = mockMembers.map((member) => member.year);
  return [...new Set(years)].sort((a, b) => a - b);
}

/**
 * Get member by ID
 * @param {number} id - Member ID
 * @returns {Object} Member object or null
 */
export function getMemberById(id) {
  return mockMembers.find((member) => member.id === id) || null;
}

/**
 * Filter members by criteria
 * @param {Object} filters - Filter criteria
 * @returns {Array} Filtered members
 */
export function filterMembers(filters) {
  return mockMembers.filter((member) => {
    if (filters.role && member.role !== filters.role) return false;
    if (filters.branch && member.branch !== filters.branch) return false;
    if (filters.year && member.year !== parseInt(filters.year)) return false;
    if (filters.search) {
      const searchLower = filters.search.toLowerCase();
      return (
        member.name.toLowerCase().includes(searchLower) ||
        member.role.toLowerCase().includes(searchLower) ||
        member.branch.toLowerCase().includes(searchLower) ||
        member.skills.some((skill) => skill.toLowerCase().includes(searchLower))
      );
    }
    return true;
  });
}
